import React from 'react'
import { Product } from '../policy-creation/models/Product'

export type ProductSelectedContext = {
  product: Product
}

export default React.createContext<ProductSelectedContext | null>(null)
